export function scrollToElement(ref: React.RefObject<HTMLDivElement>) {
  if (ref.current === null) {
    return;
  }

  ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
}
